import React from 'react';
import { Popup } from '@gravity-ui/uikit';
import { useMountedState } from 'react-use';
import { cn } from '../../../../classname';
import { FileForm } from '../../../../forms/FileForm';
import { i18n } from '../../../../i18n/widgets';
import { useBooleanState } from '../../../../react-utils/hooks';
import './view.css';
const b = cn('file-placeholder');
const placement = ['bottom-start', 'top-start', 'bottom-end', 'top-end'];
export const FilePlaceholder = ({ onCancel, onSubmit, onAttach }) => {
    const isMounted = useMountedState();
    const [loading, showLoading, hideLoading] = useBooleanState(false);
    const divRef = React.useRef(null);
    const attachHandler = React.useCallback((files) => {
        if (!onAttach)
            return;
        if (isMounted()) {
            showLoading();
            onAttach(files).finally(() => {
                if (isMounted()) {
                    hideLoading();
                }
            });
        }
    }, [isMounted, onAttach, showLoading, hideLoading]);
    return (React.createElement(React.Fragment, null,
        React.createElement("span", { ref: divRef, className: b() },
            React.createElement("a", { href: "#", className: "yfm-file" },
                React.createElement("span", { className: "yfm-file__icon" }),
                i18n('file'))),
        React.createElement(Popup, { open: true, onClose: onCancel, anchorRef: divRef, placement: placement },
            React.createElement(FileForm, { autoFocus: true, loading: loading, onCancel: onCancel, onSubmit: onSubmit, onAttach: onAttach && attachHandler }))));
};
